import { createContext, useState } from "react";

export const ImageContext = createContext();

export const ImageContextProvider = ({ children }) => {

    const [imagesList, setImagesList] = useState([]);
    const [postingImagesLoading, setPostingImagesLoading] = useState(false);

    const contextValue = {
        imagesList,
        setImagesList,
        postingImagesLoading,
        setPostingImagesLoading
    };

    return (
        <ImageContext.Provider value={ contextValue }>
            { children }
        </ImageContext.Provider>
    );
}
